<template>
    <div class="ur-data-grid__pseudo-scroll--wrapper" :class="wrapperClass">
        <!-- VERTICAL -->
        <div class="ur-data-grid__pseudo-scroll ur-data-grid__pseudo-scroll--vertical" v-if="!isHideY" :style="vertStyle">
            <div class="ur-data-grid__pseudo-scroll__button ur-data-grid__pseudo-scroll__button-top" @click="moveY(-100)">
                <div class="ur-data-grid__pseudo-scroll__button-icon"/>
            </div>
            <div class="ur-data-grid__pseudo-scroll__track" ref="trackY" :style="trackYStyle" @click="clickTrackY">
                <div class="ur-data-grid__pseudo-scroll__thumb" ref="thumbY" v-if="thumbYHack" :style="thumbYStyle" @mousedown="pdny" @mouseup="pupy"></div>
            </div>
            <div class="ur-data-grid__pseudo-scroll__button ur-data-grid__pseudo-scroll__button-bot" @click="moveY(100)">
                <div class="ur-data-grid__pseudo-scroll__button-icon"/>
            </div>
        </div>
        <!-- HORIZONTAL -->
        <div class="ur-data-grid__pseudo-scroll ur-data-grid__pseudo-scroll--horizontal" v-show="!isHideX" :style="horiStyle">
            <div class="ur-data-grid__pseudo-scroll__button ur-data-grid__pseudo-scroll__button-top" @click="moveX(-100)">
                <div class="ur-data-grid__pseudo-scroll__button-icon"/>
            </div>
            <div class="ur-data-grid__pseudo-scroll__track" ref="trackX" :style="trackXStyle" @click="clickTrackX">
                <div class="ur-data-grid__pseudo-scroll__thumb" ref="thumbX" :style="thumbXStyle" @mousedown="pdnx" @mouseup="pupx"></div>
            </div>
            <div class="ur-data-grid__pseudo-scroll__button ur-data-grid__pseudo-scroll__button-bot" @click="moveX(100)">
                <div class="ur-data-grid__pseudo-scroll__button-icon"/>
            </div>
        </div>
        <!-- RESIZE SENSOR -->
        <div class="ur-data-grid__pseudo-scroll__resizer" ex @scroll="rsOnScroll" ref="rsExpand">
            <div class="ur-data-grid__pseudo-scroll__resizer__child-expand"/>
        </div>
        <div class="ur-data-grid__pseudo-scroll__resizer" sh @scroll="rsOnScroll" ref="rsShrink">
            <div class="ur-data-grid__pseudo-scroll__resizer__child-shrink"/>
        </div>
    </div>
</template>

<script>
const isIE = /*@cc_on!@*/false || !!document.documentMode;
const THROTTLE_WAIT = isIE ? 100 : 20;
const SIZE = 17; //px, width, icon size
const MIN_THUMB = 25;
import {_rafThrottle} from '../../../util';

export default {
    name : "urDataGridContentPseudoScroll",
    inject: ['gridInfo','cellSelect'],
    data() {return {
        onMove : null,
        //isHideX : true,
        //isHideY : true,
        //dx : 0, dy : 0 -- un-reactive...
        orix : {pos:0,max:0,win:0},
        oriy : {pos:0,max:0,win:0},
        thumbYHack : true,
        
        //sizeWidth  : 0,
        //sizeHeight : 0,
    }},
    computed : {
        // [COMPUTED][FLAG] Scroll-x is on?
        isHideX() {return this.orix.max <= this.orix.win},
        // [COMPUTED][FLAG] Scroll-y is on?
        isHideY() {return this.oriy.max <= this.oriy.win},
        // [COMPUTED][FLAG] is both scroll is on?
        isBoth() {return !this.isHideX && !this.isHideY},
        // [COMPUTED][STYLE] Wrapper class
        wrapperClass() {return {
            'ur-data-grid__pseudo-scroll--both':this.isBoth,
            'ur-data-grid__pseudo-scroll--no-ctrl':this.cellSelect.onDrag,
        }},
        // [COMPUTED][STYLE] Thumb(X) class
        thumbXStyle() {
            var {_thumb, _pos} = this.thumbStyle(this.orix, this.isBoth);
            return {width :_thumb+'px', left:_pos+'px'}
        },
        // [COMPUTED][STYLE] Track(X) class
        trackXStyle() {return {width :(this.orix.win - SIZE*2)+'px'}},
        // [COMPUTED][STYLE] Thumb(Y) class
        thumbYStyle() {
            var {_thumb, _pos} = this.thumbStyle(this.oriy, this.isBoth);
            return {height:_thumb+'px', top:_pos+'px'}
        },
        // [COMPUTED][STYLE] Track(Y) class
        trackYStyle() {return {height:(this.oriy.win - SIZE*2)+'px'}},
        // [COMPUTED][STYLE] Horizontal style
        vertStyle() {return {
            bottom: (this.isBoth?SIZE:0)+"px"
        }},
        // [COMPUTED][STYLE] Horizontal style
        horiStyle() {return {
            left: this.gridInfo.vars_freezeWidth+'px',
            right: (this.isBoth?SIZE:0)+"px"
        }},
    },
    watch: {
        "gridInfo.vars_viewSize":function(v,w) {
            this.resetScroll();
        },
        "gridInfo.vars_freezeWidth":function(v,w) { // freeze에 반응하여 스크롤 조정
            var sw = this.gridInfo.refs.scrollWrapper;
            if(!sw) return;
            this.setScrollX({pos:sw.scrollLeft,max:sw.scrollWidth,win:sw.clientWidth})
        },
        "gridInfo.vars_tableWidth":function(v,w) {
            this.resetScroll();
        },
    },
    mounted() {
        // 1. init resizer scroll
        this.rsOnScroll();
        this.gridInfo.eventBus.$on('scroll-adjust',this.rsOnScroll);
    },
    methods : {
        // [EVENT] Click track
        clickTrackY(e) {
            var th = this.$refs.thumbY, thRect = th.getBoundingClientRect();
            if(e.target === th) {return;}
            if(e.clientY < thRect.top) { // to upward
                this.moveY(-this.oriy.win);
            } else if( thRect.bottom < e.clientY) { // to downward
                this.moveY(this.oriy.win);
            }
        },
        // [EVENT] Click track
        clickTrackX(e) {
            var th = this.$refs.thumbX, thRect = th.getBoundingClientRect();
            if(e.target === th) {return;}
            if(e.clientX < thRect.left) { // to left
                this.moveX(-this.orix.win);
            } else if( thRect.right < e.clientX) { // to right
                this.moveX(this.orix.win);
            }
        },
        
        // [UTIL] make thumb style
        thumbStyle({pos, max, win}, bothFlag) {
            // 1. calc size
            /* var _height = win - SIZE * (2+(bothFlag?1:0)); */
            var _height = win - 0 * (2+(bothFlag?1:0));
            var _thumb = ~~(_height * win / max);
            if(_thumb < MIN_THUMB ) {_thumb = MIN_THUMB;}
            // 2. calc pos
            var _max = _height - _thumb;
            var _pos = ~~(_max * pos / (max - win));
            if(_pos < 0 ) _pos = 0;
            else if(_pos > _max) _pos = _max;
            // 3. return value
            return {_thumb, _pos}
        },
        // [MOVE] click move button(up/down)
        moveY(offset) {
            this.emitOnScroll({offset})
        },
        moveX(offsetX) {
            this.emitOnScroll({offsetX})
        },
        // [EVENT][Y] Start drag scroll
        pdny(e) {
            // 1. Prevent default
            e.preventDefault();
            // 2. Pointer setting
            var pl = this.$refs.trackY, plRect = pl.getBoundingClientRect();
            var el = this.$refs.thumbY, elRect = el.getBoundingClientRect();
            //fixme safari 12를 포기합시다
            document.body.addEventListener('mousemove', this.pmvy);
            document.body.addEventListener('mouseup', this.pupy);
            // el.onmousemove = this.pmvy;
            // 3. Set init position
            this.dy = plRect.top + (e.clientY - elRect.top);
        },
        // [EVENT][Y] on-drag scroll
        pmvy:_rafThrottle(function(e) {
            // 1. prepare values
            var pl = this.$refs.trackY, plRect = pl.getBoundingClientRect();
            var el = this.$refs.thumbY, elRect = el.getBoundingClientRect();
            // 3. cacl next pos
            var pos = e.clientY - this.dy;
            var max = plRect.height - elRect.height;
            if(pos < 0) {pos = 0}
            else if(pos > max) {pos = max}
            // 3. scroll top
            el.style.top = pos+'px';
            // x. action something
            this.emitOnScroll({posy:pos, maxy:max})
        }),
        // [EVENT][Y] End drag scroll
        pupy(e) {
            //fixme safari 12를 포기합시다
            document.body.removeEventListener('mousemove', this.pmvy);
            document.body.removeEventListener('mouseup', this.pupy);
            this.dy = undefined;
        },
        
        // [METHOD][Y] for setScroll from outer 
        setScrollY(oriy) {
            if(this.dy) {
                var p = this.oriy, n = oriy;
                if(p.max !== n.max) { // Max is Chanaged...?!
                    this.dy += ~~(n.pos/p.max*n.win - n.pos/n.max*n.win);
                }
            }
            this.oriy = oriy;
            if(this.oriy.max !== 0 && this.orix.max ===0){
                var sw = this.gridInfo.refs.scrollWrapper;
                if(!sw) return;
                this.setScrollX({pos:sw.scrollLeft,max:sw.scrollWidth,win:sw.clientWidth})
            }
            // forceUpdate도 먹히지 않아 안 좋은 방법을 사용
            this.thumbYHack = false;
            this.$nextTick(() => {
                this.thumbYHack = true;
            })
        },
        //-------------------------------
        // [EVENT][X] Start drag scroll
        pdnx(e) {
            // 1. Prevent default
            e.preventDefault();
            // 2. Pointer setting
            var pl = this.$refs.trackX, plRect = pl.getBoundingClientRect();
            var el = this.$refs.thumbX, elRect = el.getBoundingClientRect();
            // el.setPointerCapture(e.pointerId)
            // el.onmousemove = this.pmvx;
            //fixme safari 12를 포기합시다
            document.body.addEventListener('mousemove', this.pmvx);
            document.body.addEventListener('mouseup', this.pupx);

            // 3. Set init position
            this.dx = plRect.left + (e.clientX - elRect.left);
        },
        // [EVENT][X] on-drag scroll
        pmvx:_rafThrottle(function(e) {
            // 1. prepare values
            var pl = this.$refs.trackX, plRect = pl.getBoundingClientRect();
            var el = this.$refs.thumbX, elRect = el.getBoundingClientRect();
            // 3. cacl next pos
            var pos = e.clientX - this.dx;
            var max = plRect.width - elRect.width;
            if(pos < 0) {pos = 0}
            else if(pos > max) {pos = max}
            // 3. scroll top
            el.style.left = pos+'px';
            // x. action something
            this.emitOnScroll({posx:pos, maxx:max})
        }),
        // [EVENT][X] End drag scroll
        pupx(e) {
            //fixme safari 12를 포기합시다
            document.body.removeEventListener('mousemove', this.pmvx);
            document.body.removeEventListener('mouseup', this.pupx);
        },
        // [METHOD][X] for setScroll from outer
        setScrollX(orix) {
            this.orix = orix;
            if(this.orix.max !== 0 && this.oriy.max ===0){
                var sw = this.gridInfo.refs.scrollWrapper;
                if(!sw) return;
                this.setScrollY({pos:sw.scrollTop,max:sw.scrollHeight,win:sw.clientHeight})
            }
        },
        // [METHOD] Emit event to parent
        emitOnScroll({posx, maxx, posy, maxy, offset, offsetX}) {
            this.$emit('on-scroll',{posx,maxx, posy, maxy, offset, offsetX})
        },
        // [METHOD] Reset scroll size/pos
        resetScroll() {
            this.$nextTick(()=> {
                var sw = this.gridInfo.refs.scrollWrapper;
                if(!sw) return;
                this.setScrollX({pos:sw.scrollLeft,max:sw.scrollWidth,win:sw.clientWidth})
                this.setScrollY({pos:sw.scrollTop,max:sw.scrollHeight,win:sw.clientHeight})
            })
        },
        // [METHOD] RESIZE SENSOR, hello?
        rsOnScroll:_rafThrottle(function(e) {
            var elRect = this.gridInfo.refs.content.getBoundingClientRect();
            var nWidth  = elRect.width,
                nHeight = elRect.height;
            if(this.sizeWidth !== nWidth || this.sizeHeight !== nHeight) {
                // 1. set size
                this.sizeWidth  = nWidth;
                this.sizeHeight = nHeight;
                // 2. Resize track --- LOGIC ---
                this.resetScroll();
                // 3. emit scroll
                this.gridInfo.func.fireEvent("resize",nWidth, nHeight);
            }
            this.rsSetScroll();
        }),
        // [METHOD] RESIZE SENSOR, setScroll right-bottom
        rsSetScroll() {
            if(this.$refs.rsExpand) {
                this.$refs.rsExpand.scrollLeft = 10000000;
                this.$refs.rsExpand.scrollTop  = 10000000;
            }
            if(this.$refs.rsShrink) {
                this.$refs.rsShrink.scrollLeft = 10000000;
                this.$refs.rsShrink.scrollTop  = 10000000;
            }
        },
        adjustScroll() {
            let sw = this.gridInfo.refs.scrollWrapper;
            if(!sw) {return;}
            setTimeout(() => {
                if(sw.scrollLeft !== this.orix.pos){
                    this.$emit('adjust-scroll', sw.scrollLeft);
                }
            })
        },
    }
}
</script>

